import React from "react";
import PostJobHeader from "../post/PostJobHeader";
import { useLocation, useNavigate, useParams } from "react-router-dom";

function PostJobPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { source_slug = "", job_slug = "" } = useParams();

  const job = location.state?.job || null;
  const editMode = !!job;

  const handleClose = () => {
    navigate(-1);
  };
  return (
    <div className="container-fluid">
      <div className="w-100 pb-5">
        {editMode ? <h3>Update Job</h3> : <h3>Post a New Job</h3>}

        <div className="card-1 p-lg-4 w-100">
          <PostJobHeader
            refreshlist={() => { }}
            open={true}
            handleClose={handleClose}
            editMode={editMode}
            jobData={job}
            sourceSLug={source_slug}
          />
        </div>
      </div>
    </div>
  );
}

export default PostJobPage;
